module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-1x1-4f8ca69b1bc4e907390095c2da0274d2.jpg";